import React from 'react';

type Props = {
  image: string;
  title: string;
  content: string;
};

export default function CarouselItem({ image, title, content }: Props) {
  return (
    <div className="absolute left-1/2 top-1/2 block w-full -translate-x-1/2 -translate-y-1/2 p-6">
      <div className="flex justify-center rounded-full">
        <img
          src={image}
          className="mt-5 rounded-full sm:h-20 sm:w-20 lg:h-40 lg:w-40"
        />
      </div>
      <div className="mt-4 text-center">
        <h3 className="text-lg font-bold sm:text-sm">{title}</h3>
        <p className="mt-5 text-sm font-normal leading-5 lg:px-[7%]">
          {content}
        </p>
      </div>
    </div>
  );
}
